import constants from '@Common/Core/Constant';
import { CellData } from '@InstanceFactory';

export namespace comparers {
    export function changeNationalLetters(sourseString: string): string {
        if (!sourseString.replace(/[a-zA-Z0-9\\/]/g, '').length) {
            return sourseString;
        }
        for (const eq of constants.nationalLettersEquivalents) {
            sourseString = sourseString.replace(eq.letters, eq.base);
        }
        return sourseString;
    }

    export function alphabetSortComparer(value1: any, value2: any): number {
        if (typeof value1 === 'string') {
            value1 = changeNationalLetters(value1);
        }
        if (typeof value2 === 'string') {
            value2 = changeNationalLetters(value2);
        }

        return comparers.comparer(value1, value2);
    }

    export function comparer(value1: any, value2: any): number {
        if (typeof value1 === 'string' && typeof value2 === 'string') {
            return comparers.stringComparer(value1, value2);
        }
        if (value1 > value2) {
            return 1;
        }
        if (value1 < value2) {
            return -1;
        }

        return 0;
    }

    export function stringComparer(value1: string, value2: string): number {
        if (!value1 && !value2) {
            return 0;
        }
        if (!value1) {
            return -1;
        }
        if (!value2) {
            return 1;
        }

        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();

        if (value1 < value2) {
            return -1;
        } else if (value1 > value2) {
            return 1;
        } else {
            return 0;
        }
    }

    export function alphabetSortComparerByName(value1: any, value2: any): number {
        return comparers.alphabetSortComparer(value1.name, value2.name);
    }

    export function dataCellsComparer(cell1: CellData, cell2: CellData, sortById: boolean): number {
        if (cell1.key === cell2.key) {
            return 0;
        }
        if (cell1.key == null || cell1.key === '') {
            return -1;
        }
        if (cell2.key == null || cell2.key === '') {
            return 1;
        }
        if (sortById) {
            return comparers.alphabetSortComparer(cell1.key, cell2.key);
        }
        return comparers.alphabetSortComparer(cell1.value, cell2.value);
    }
}
